import * as types from 'actions/actionTypes';
import initialState from 'reducers/initialState';

export default (state = initialState.mealSurvey, action) => {
  switch (action.type) {
    case types.MEAL_SURVEY_LOAD.SUCCESS:
      return { ...action.mealSurvey };

    case types.LOG_OUT.SUCCESS:
      return initialState.mealSurvey;

    default:
      return state;
  }
};
